<template>
  <H5Layout title="个人中心" active="person">
    <div class="person-h5">
      <Person @person_fff_user="onUserUpdate"></Person>
      <div class="person-h5-logout">
        <el-button type="danger" plain size="medium" @click="logoutClick" class="person-h5-logout-btn">
          退出登录
        </el-button>
      </div>
    </div>
  </H5Layout>
</template>

<script>
import H5Layout from "./H5Layout.vue";
import Person from "@/vue_views/components/Person.vue";
import {clearRouter} from '@/js_router/router.js';

export default {
  name: "PersonH5",
  components: {
    H5Layout,
    Person
  },
  methods: {
    // 个人资料更新后同步本地user
    onUserUpdate(val) {
      this.$http.post("user/select", val).then(res => {
        if (res.data.code === "200") {
          const u = res.data.object;
          const local = JSON.parse(localStorage.getItem("user")) || {};
          u.token = local.token; // 保留原有token
          localStorage.setItem("user", JSON.stringify(u));
          this.$message.success("个人信息已更新");
        }
      })
    },
    logoutClick() {
      localStorage.removeItem("user");
      localStorage.removeItem("menuList");
      this.$message.success("退出成功");
      clearRouter();
      this.$router.push("/login_h5");
    }
  }
}
</script>

<style scoped>
.person-h5-logout {
  margin-top: 16px;
}
.person-h5-logout-btn {
  width: 100%;
  letter-spacing: 2px;
}
</style>
